export default __webpack_public_path__ + "static/media/ysb.318b2d3f.png";